<template lang='pug'>
  .new-order-dialog.component(v-if='!step')
    h5.heading {{ $t('Make a Reservation by') }}
    h6.heading {{ $t('selecting a date & time below') }}

    vue-cal.vuecal--blue-theme.calendar(
      default-view="week"
      small
      :time-step='30'
      :disable-views="['years', 'month', 'year']"
      :selected-date="new Date()"
      :time-from='opening'
      :time-to='closing'
      :twelveHour='true'
      :events="events"
      @cell-click='set'
      style="height: 750px"
    )

  .new-order-dialog.component(v-else)
    h5.heading {{ $t('Please Check and Confirm') }}
    h6.heading {{ $t('your reservation details below') }}
    bf-wrapper.smaller.confirmation.content
      .rsv-dtls
        table
          thead
            tr
              th {{ $t('Business Name') }}
              td {{ business.name }}
            tr(v-if='customer')
              th {{ $t('Customer Email') }}
              td {{ customer.email }}
            tr
              th {{ $t('Service') }}
              td.emphasize {{ reservation.service.title }}
            tr
              th {{ $t('Price') }}
              td ${{ reservation.service.price }}
            tr
              th {{ $t('Date') }}
              td {{ reservation.datetime.start.toLocaleDateString() }}
            tr
              th {{ $t('Reserved Time') }}
              td.emphasize {{ reservation.datetime.start.toLocaleTimeString() }}
            tr
              th {{ $t('Appointment Time') }}
              td {{ reservation.datetime.end.toLocaleTimeString() }}
      bf-flex.space-between
        bf-button.back.basic.secondary(@click.native='step--')
          template(v-slot:text) {{ $t('Back') }}
        bf-button.confirm.basic(@click.native='confirm')
          template(v-slot:text) {{ $t('Confirm') }}
</template>

<script>
  import { db } from '@/main'
  import VueCal from 'vue-cal'
  import 'vue-cal/dist/vuecal.css'

  export default {
    name: 'new-order-dialog.component',

    props: ['user', 'account', 'business', 'service_id', 'customer'],

    components: {
      VueCal
    },

    data() {
      return {
        reservation: {},
        reservations: [],
        services: [],
        step: 0
      }
    },

    firestore() {
      return {
        reservations: {
          ref: db.collection('reservations').where( 'business_id', '==', this.business.id ),
        },
        services: db.collection('services').where( 'business_id', '==', this.business.id )
      }
    },

    computed: {
      events() {
        return this.reservations.map( r =>
          ({ ...r, ...{
            startDate: r.datetime.start.toDate(),
            endDate: r.datetime.end.toDate()
          }})
        )
      },

      opening() {
        if ( !this.business.hours || !this.business.hours.opening ) return 0
        let d = new Date(this.business.hours.opening)
        let mins = d.getUTCHours() * 60 + d.getUTCMinutes()
        return mins
      },

      closing() {
        if ( !this.business.hours || !this.business.hours.closing ) return 24 * 60
        let d = new Date(this.business.hours.closing)
        let mins = d.getUTCHours() * 60 + d.getUTCMinutes()
        return mins
      }
    },

    methods: {
      set(start) {
        if ( !this.service_id || !this.customer ) return this.$emit('notify', 'Please select a service and customer before continuing')
        if ( start ) {
          start.setMinutes( Math.floor( start.getMinutes() / 15 ) * 15 )
          let service = this.services.find( s => s.id == this.service_id )
          let end = new Date(start)
          end.setMinutes(
            start.getMinutes() +
            parseInt(service.duration - 1)
          )

          this.reservation = {
            business_id: this.business.id,
            service_id: this.service_id,
            account_id: this.customer.account_id,
            user_id: this.customer.account_id,
            service: service,
            datetime: { start: start, end: end }
          }

          // If no overlaps allow reservation.  Else prompt for another datetime
          let available = !this.events.filter( e => e.startDate < end && e.startDate > start ).length
          if ( available ) this.step = 1
        }
      },

      confirm() {
        db.collection('reservations').add(this.reservation).then( doc =>
          db.collection( 'customers' )
          .where( 'account_id', '==', this.account.id )
          .where( 'business_id', '==', this.business.id )
          .get().then( snap => {
            // Initial reservations?  Add as customer if not already exists
            if ( !snap.docs.length ) db.collection( 'customers' ).add({
              email: this.account.email,
              name: this.account.name || '',
              account_id: this.account.id,
              account: this.account,
              business_id: this.business.id,
              business: this.business,
              initial_reservation: doc,
              invitation: {invited: true, joined: true}
            })
            this.$emit('close')
            this.$emit(
              'notify',
              `You have made a reservation with ${this.business.name}`
            )
          })
        )
      }
    }
  }
</script>
<style scoped lang='stylus'>
  >>> .vuecal__event
    background green
    color green
    padding-bottom 1px

  >>> .vuecal__time-cell
    padding-right 4px

  >>> .weekday-label
    font-weight bold
  >>> .vuecal__heading.today
    font-weight bold
    background rgb(54 131 149)
    color white
  >>> .vuecal__time-column
    font-weight bold
    background rgb(54 131 149)
  >>> .vuecal__time-cell
    color white
  >>> .vuecal__now-line
    color orange
    border-top: 3px solid
  
  .new-order-dialog
    .heading
      color rgb( 255 75 25 )
      text-align center
    .calendar
      margin-top 12px
      box-shadow var(--shadow-box-shallow)

    // .confirmation
  .rsv-dtls
    margin 24px auto
    border 1px solid rgba( 0 0 0 .1 )
    border-radius 12px
    overflow hidden
    box-shadow var(--shadow-box-shallow)
  table
    width 100%
    text-align left
    font-size 1.02em
    th, td
      padding 12px 16px
    th
      background rgba( 0 75 150 .1 )
      text-align right
      width 108px
      font-weight bold
    tr:nth-child(odd)
      background rgba( 0 0 0 .02 )
    .emphasize
      font-weight bold
</style>
